import { observer } from 'mobx-react-lite'
import { type User } from '@/features/iam/users/User'
import { type TimeRange } from '@/infra/time-range'
import {
  ConsultationPendingBookingDay,
  ConsultationPendingBookingModal,
  TimeSlotListItem,
} from '@/features/jobs/details/components/ConsultationPendingBookingModal'
import { type ConsultationPendingBookingModalViewModel } from './ConsultationPendingBookingModalViewModel'

export interface ConsultationPendingBookingModalContainerProps {
  vm: ConsultationPendingBookingModalViewModel
}

export const ConsultationPendingBookingModalContainer = observer(
  function ConsultationPendingBookingModalContainer({
    vm,
  }: ConsultationPendingBookingModalContainerProps) {
    return (
      <ConsultationPendingBookingModal
        showing={vm.modal.showing}
        onClose={vm.close}
        requestedLength={vm.requestedLength}
        isForTaxJob={vm.consultationIsForTaxJob}
        onForfeit={vm.forfeit}
        onBook={vm.book}
      >
        {vm.availableDays.map((d) => (
          <ConsultationPendingBookingDay
            key={d.formattedDay}
            title={d.formattedDay}
          >
            {d.timeSlots.map((t, i) => (
              <TimeSlotListItemContainer key={i} index={i} vm={vm} range={t} />
            ))}
          </ConsultationPendingBookingDay>
        ))}
      </ConsultationPendingBookingModal>
    )
  },
)

interface TimeSlotListItemContainerProps {
  index: number
  range: TimeRange
  vm: ConsultationPendingBookingModalViewModel
}

const TimeSlotListItemContainer = observer(function TimeSlotListItemContainer({
  index,
  range,
  vm,
}: TimeSlotListItemContainerProps) {
  return (
    <TimeSlotListItem
      index={index}
      startTime={range.startTime}
      endTime={range.endTime}
      isSelected={vm.isTimeSlotSelected(range)}
      isBooked={Boolean(vm.bookedConsultationAt(range))}
      onSelect={() => vm.selectTimeSlot(range)}
      clientAvatar={toAvatarSubject(vm.clientMember.user)}
      currentMemberAvatar={toAvatarSubject(vm.currentMember.user)}
    />
  )
})

function toAvatarSubject(user: User) {
  return {
    avatar: user.avatar,
    avatarFallback: user.avatarFallback,
    displayName: user.displayName,
  }
}
